import { css } from '@emotion/css';

export const singleMonthDayButtonStyles = css`
  width: 4rem;
  height: 4rem;
`;

export const dayButtonRootStyles = css`
  .selected {
    color: var(--text-white);
  }

  .selected:hover {
    background-color: var(--interactive-primary);
  }
`;

export const inlineDatePickerStyles = css`
  border-radius: 1.2rem;
`;
